import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the "Review & Confirm" step of the OLD Shift Request form is viewed
 * Event: dental_portal:shift_request:review_confirm_viewed
 */
export function fireV0ReviewConfirmPageViewed(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:review_confirm_viewed', {
    version: 202401,
  });
}
